import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class shuttleBusService extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />

                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Exhibitors
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Shuttle Bus Service
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <div className="marquee_section">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    {/* <h6>Helpline for Shuttle Bus Services - +91 97171 34075 / +91 97175 24074 (Active from 04th December 2026 to 6th December 2026) Kindly Locate Volunteer with Placard.</h6> */}
                                    <h4 className="pt-3">Shuttle Bus service guidelines coming soon</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section style={{ height: 100 }}>
                        {/* <section class="Shuttle_Bus_Service_section for_coming_soon" style="height:100vh"> */}
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Bus Service</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">

                                        </h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(shuttleBusService));